import { useContext, useEffect, useState } from "react";
import { AuthContext } from "@CONTEXTS";

const useAuthority = (authorityName) => {
  const [isAuth, setIsAuth] = useState(true);
  const { info } = useContext(AuthContext);

  useEffect(() => {
    if (info?.authorities.includes(authorityName)) {
      setIsAuth(true);
    } else {
      setIsAuth(false);
    }
  }, [authorityName, info]);

  return isAuth;
};

export default useAuthority;
